import { Routes } from '@angular/router';
import { FINANCE, INDIVIDUAL } from '@rma/generic/domain/types';
import { setupPageUrlMatcher } from '@rma/public/generic/ui/pagination';
import { ProfileReviewsComponent } from '@rma/public/profiles/private/orc-reviews';
import { mortgageBrokerProfileResolver } from './domain/finance.guard';
import { MortgageBrokerProfileComponent } from './orc-mortgage-broker-profile/mortgage-broker-profile.component';

export const mortgageBrokerProfileRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'overview',
  },
  {
    path: '',
    resolve: {
      profile: mortgageBrokerProfileResolver,
    },
    children: [
      {
        path: 'overview',
        component: MortgageBrokerProfileComponent,
      },
      {
        matcher: setupPageUrlMatcher('reviews'),
        component: ProfileReviewsComponent,
        data: {
          verticalType: FINANCE,
          profileType: INDIVIDUAL,
        },
      },
      {
        matcher: setupPageUrlMatcher('contact'),
        loadComponent: () => import('@rma/public/profiles/private/orc-contact'),
      },
      {
        path: 'map',
        loadComponent: () => import('@rma/public/profiles/map'),
        data: {
          hideFooter: true,
          fullWidthHeader: true,
        },
      },
    ],
  },
];
